import { Feature } from '@ts-core/utils/features';

import ThreadsPage from '@ts-core/pages/Forum/ThreadsPage';
import ThreadDetailsPage from '@ts-core/pages/Forum/ThreadDetailsPage';
import EditThreadPage from '@ts-core/pages/Forum/EditThreadPage';
import NewThreadPage from '@ts-core/pages/Forum/NewThreadPage';
import EditThreadAnswerPage from '@ts-core/pages/Forum/EditThreadAnswerPage';

import RankingsPage from 'modules/rankings/pages/RankingsPage';

import StudentDashboardPage from 'modules/dashboard/pages/StudentDashboardPage';

import MediaPlayerPage from 'modules/media/pages/MediaPlayerPage';

import CourseStatsPage from 'modules/courses/pages/CourseStatsPage';

import SubjectPage from 'modules/subjects/pages/SubjectPage';
import SubjectStatsPage from 'modules/subjects/pages/SubjectStatsPage';

import AssignmentsListPage from 'modules/assignments/pages/AssignmentsListPage';
import DoAssignmentPage from 'modules/assignments/pages/DoAssignmentPage';
import AssignmentDetailsPage from 'modules/assignments/pages/AssignmentDetailsPage';

import PracticeSessionsListPage from 'modules/practice/pages/PracticeSessionsListPage';
import DoPracticeSessionPage from 'modules/practice/pages/DoPracticeSessionPage';
import PracticeSessionDetailsPage from 'modules/practice/pages/PracticeSessionDetailsPage';

import ActivitiesPage from 'modules/activities/pages/ActivitiesPage';
import ActivityPage from 'modules/activities/pages/ActivityPage';

const studentPrivateRoutes = [
  { component: StudentDashboardPage, path: '/dashboard' },

  {
    component: MediaPlayerPage,
    path: '/subjects/:subjectId/media-player/:mediaId',
    requiredFeatures: [Feature.VideoOnDemand],
  },
  { component: SubjectPage, path: '/subjects/:subjectId/:tabSlug' },

  /**
   * Assignments
   */
  {
    component: DoAssignmentPage,
    path: '/assignments/:assignmentId/do',
  },
  {
    component: AssignmentDetailsPage,
    path: '/assignments/:assignmentId/details',
  },
  { component: AssignmentsListPage, path: '/assignments' },

  /**
   * Practice sessions
   */
  {
    component: DoPracticeSessionPage,
    path: '/practice/:practiceSessionId/do',
  },
  {
    component: PracticeSessionDetailsPage,
    path: '/practice/:practiceSessionId/results',
  },
  {
    component: PracticeSessionsListPage,
    path: '/practice',
    exact: true,
  },

  {
    component: SubjectStatsPage,
    path: '/stats/subjects/:subjectId',
  },
  {
    component: CourseStatsPage,
    path: '/stats',
    exact: true,
  },
  {
    component: RankingsPage,
    path: '/rankings/:rankingType(general|assignments|subjects)',
    requiredFeatures: [Feature.Ranking],
  },

  {
    component: NewThreadPage,
    path: '/forum/new-thread',
    requiredFeatures: [Feature.Forum],
  },
  {
    component: EditThreadPage,
    path: '/forum/:threadId/edit',
    requiredFeatures: [Feature.Forum],
  },
  {
    component: EditThreadAnswerPage,
    path: '/forum/:threadId/answers/:answerId/edit',
    requiredFeatures: [Feature.Forum],
  },
  {
    component: ThreadDetailsPage,
    path: '/forum/:threadId',
    requiredFeatures: [Feature.Forum],
  },
  {
    component: ThreadsPage,
    path: '/forum',
    requiredFeatures: [Feature.Forum],
  },

  {
    component: ActivityPage,
    path: '/activities/:activityId',
    requiredFeatures: [Feature.Activities],
  },
  {
    component: ActivitiesPage,
    path: '/activities',
    requiredFeatures: [Feature.Activities],
  },
];

export default studentPrivateRoutes;
